module.exports = __webpack_public_path__ + "static/media/neutral_event_response.d1a95f65.png";